import { SidebarTrigger } from "@components/ui/sidebar";
import { ROLES } from "@user-management-context/shared/domain/types/enums/roles";
import { useSession } from "@user-management-context/primary/hooks/use-session";
import { AdminTopBar } from "@user-management-context/primary/shared/admin-top-bar.container";
import { StudentBalanceTopbarContainer } from "@shared-kernel/primary/shared/student-balance-topbar/student-balance-topbar.container";
import { TeacherBalanceTopbarContainer } from "@shared-kernel/primary/shared/teacher-balance-topbar/teacher-balance-topbar.container";

export const RoleTopBar = () => {
  const { user, activeRole } = useSession();
  if (!user) return null;

  if (user.isAdmin) return <AdminTopBar />;
  if (activeRole === ROLES.STUDENT) return <StudentBalanceTopbarContainer />;
  if (activeRole === ROLES.TEACHER) return <TeacherBalanceTopbarContainer />;
  if (activeRole === ROLES.PROVIDER) {
    return <SidebarTrigger className="absolute left-2 top-2" />;
  }
  return null;
};
